import {view, css} from '@sail/ui/deprecated';
import {useEffect} from 'react';
import {useWidgetTitle} from '@stripe-internal/conversations-ui';
import {SpinnerRow} from '../components/SpinnerRow';
import {Title} from '../components/Title';

export function LoadingScreen() {
  const {setTitle} = useWidgetTitle();

  useEffect(() => {
    setTitle(<Title />);
  }, [setTitle]);

  return (
    <view.div
      data-testid="loading-screen"
      css={{
        display: css.value('flex'),
        alignItems: css.value('center'),
        height: css.value('100%'),
      }}
    >
      <SpinnerRow size="large" />
    </view.div>
  );
}
